<template>
    <div class="com-apply-website">
        <step-header activeKey="1"></step-header>
        <div class="com-apply-website__main">
            <div class="com-card-title">网站信息</div>
            <div class="com-apply-website__form com-form">
                <div :class="['com-form-item', {'is-error': error.logo}]">
                    <label class="com-form__item-label">网站LOGO </label>
                    <file-upload
                        class="com-btn"
                        @input-filter="inputFilter"
                        @input-file="inputFile"
                        ref="upload">
                        <i class="icon icon-loading" v-if="uploading"/>
                        上传图片
                    </file-upload>
                    <!-- <input class="com-form__item-input" type="text" v-model="logo" @input="enter" /> -->
                    <span class="com-form__item-explain" v-if="error.logo">请上传网站LOGO</span>
                </div>
                <div class="com-form-item com-form-item--nolabel" v-if="logo">
                    <img :src="logo" class="logo"/>
                </div>
                <div :class="['com-form-item', {'is-error': error.screen_name}]">
                    <label class="com-form__item-label">网站名称 </label>
                    <input class="com-form__item-input" type="text" v-model="screen_name" @input="enter" placeholder="如 顺风物流" />
                    <span class="com-form__item-explain" v-if="error.screen_name">请输入网站名称</span>
                </div>
            </div>
            <div class="com-card-title">设置后台账户</div>
            <div class="com-apply-website__form com-form">
                <div :class="['com-form-item', {'is-error': error.account}]">
                    <label class="com-form__item-label">用户名 </label>
                    <input class="com-form__item-input" type="text" v-model="account" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.account">请输入用户名</span>
                </div>
                <div :class="['com-form-item', {'is-error': error.password}]">
                    <label class="com-form__item-label">密码 </label>
                    <input class="com-form__item-input" type="text" v-model="password" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.account">请输入密码</span>
                </div>
                <div :class="['com-form-item', {'is-error': error.rpassword||error.noDulpcate}]">
                    <label class="com-form__item-label">确认密码 </label>
                    <input class="com-form__item-input" type="text" v-model="rpassword" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.rpassword">请输入确认密码</span>
                    <span class="com-form__item-explain" v-if="error.noDulpcate">两次密码不一致</span>
                </div>
                <div class="com-form-item com-form-item--nolabel">
                    <button class="com-btn com-btn-submit" @click="back" style="margin-right: 10px;">上一步</button>
                    <button class="com-btn com-btn-primary com-btn-submit" @click="next"><i class="icon icon-loading" v-if="loading"/>下一步</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StepHeader from './step-header'
import * as xml2js from 'xml2js';
export default {
    name: 'apply-website',
    components: {
        StepHeader,
    },
    data() {
        return {
            logo: '',
            screen_name: '',
            account: '',
            password: '',
            rpassword: '',
            error: {},
            uploading: false,
            loading: false
        }
    },
    created() {
        const params = JSON.parse(sessionStorage.getItem('params') || '{}');
        this.logo = params.logo;
        this.screen_name = params.screen_name;
        this.account = params.account;
        this.password = params.password;
        this.rpassword = params.rpassword;
    },
    methods: {
        inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                if (!/\.(png?|jpg?|jpeg?|gif?PNG?|JPG?|JPEG?|GIF?)$/i.test(newFile.name)) {
                    alert('只能上传后缀名为jpg，png，jpeg，gif的图片文件')
                    return prevent()
                }
            }
        },
        inputFile(newFile, oldFile) {
            const _this = this;
            if (newFile) {
                const suffix = newFile.name.split('.')[1];
                _this.uploading = true;
                this.$axios.post('/common/oss-upload-token', {suffix}).then(res => {
                    const uploadParams = res.data.response.data;
                    const param = new FormData();
                    Object.entries(uploadParams.inputs).map(([key, value]) => param.append(key, value));
                    param.append('file', newFile.file);
                    if(res.data.meta.code === 0) {
                        this.$axios.post(uploadParams.url, param).then(oss => {
                            const {parseString} = xml2js;
                            parseString(oss.data, (err, result) => _this.logo = result.PostResponse.Location[0]);
                            _this.uploading = false;
                            _this.$set(this.error, 'logo', false)
                        })
                    }
                })
            }
        },
        enter() {
            if(this.screen_name) {
                this.$set(this.error, 'screen_name', false)
            }
            if(this.account) {
                this.$set(this.error, 'account', false)
            }
            if(this.password) {
                this.$set(this.error, 'password', false)
            } 
            if(this.rpassword) {
                this.$set(this.error, 'rpassword', false)
            } 
            if(this.password === this.rpassword) {
                this.$set(this.error, 'noDulpcate', false)
            }
        },
        back() {
            this.$router.push({path: `/merchant/apply`, query: {s: 0}});
            this.$emit('end')
        },
        next() {
            if(!this.logo) {
                this.$set(this.error, 'logo', true)
            }
            if(!this.screen_name) {
                this.$set(this.error, 'screen_name', true)
            } 
            if(!this.account) {
                this.$set(this.error, 'account', true)
            } 
            if(!this.password) {
                this.$set(this.error, 'password', true)
            } 
            if(!this.rpassword) {
                this.$set(this.error, 'rpassword', true)
            } 
            if(this.password && this.rpassword && this.password !== this.rpassword) {
                this.$set(this.error, 'noDulpcate', true)
            } 
            if(this.logo && this.screen_name && this.account && this.password && this.rpassword && this.password === this.rpassword) {

                this.loading = true;
                this.$axios.post('/merchant/validate-account', {account: this.account}).then(res => {
                    this.loading = false;
                    if (res.data.meta.code === 0) {
                        const params = JSON.parse(sessionStorage.getItem('params') || '{}');
                        params.logo = this.logo;
                        params.screen_name = this.screen_name;
                        params.account = this.account;
                        params.password = this.password;
                        params.rpassword = this.rpassword;
                        sessionStorage.setItem('params', JSON.stringify(params));
                        this.$router.push({path: `/merchant/apply`, query: {s: 2}});
                        this.$emit('end')
                    } else {
                        alert(res.data.meta.error)
                    }
                })
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .com-apply-website {
        &__form {
            margin-top: 30px;
        }
        .com-divider {
            margin: 40px 0 24px;
        }
        .com-btn-submit {
            width: 100px;
            border-radius: 20px;
            margin-top: 20px;
        }
        .logo {
            max-width: 200px;
            box-shadow: 0 0 4px rgba(0,0,0,.1);
        }
    }
</style>

